import { componentProvider } from 'js-component-framework';
import FormAssemblyForm from './form-assembly-form';
import './form-assembly-form.scss';

const formAssemblyFormConfig = {
  name: 'form-assembly-form',
  component: FormAssemblyForm,
};

componentProvider(formAssemblyFormConfig);
